import { Link } from 'react-router-dom';
import { HR_CERTIFICATIONS_ROUTE, HR_COMPLAINTS_ROUTE, HR_EMPLOYEES_ROUTE, t, type StringKey } from '@bms2/shared';
import styles from './HrPages.module.css';

/** The HR pages the side menu's one Employees row leads to, linked from each other (piece 34; decision 1467). */
const PAGES: readonly { route: string; label: StringKey }[] = [
  { route: HR_EMPLOYEES_ROUTE, label: 'hr.nav.employees' },
  { route: HR_CERTIFICATIONS_ROUTE, label: 'hr.nav.certifications' },
  { route: HR_COMPLAINTS_ROUTE, label: 'hr.nav.complaints' },
];

/** A row of links between the HR pages, the one being read marked rather than linked. */
export function HrPagesNav({ current }: { current: string }) {
  return (
    <nav aria-label={t('hr.nav.label')}>
      <ul className={styles.pagesNav} data-hr-pages-nav="true">
        {PAGES.map((page) => (
          <li key={page.route}>
            {page.route === current
              ? <span className={styles.pagesNavCurrent} aria-current="page">{t(page.label)}</span>
              : <Link to={page.route}>{t(page.label)}</Link>}
          </li>
        ))}
      </ul>
    </nav>
  );
}
